import {Injectable} from '@angular/core';
import {ApiServiceProvider} from "../api-service/api-service";

/*
  Generated class for the PaymentServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class BalanceServiceProvider {

  constructor(public apiService: ApiServiceProvider) {
  }

  get(store = null) {
    if(store) {
      return this.apiService.get(`/balances?store=${store}`);
    } else {
      return this.apiService.get(`/balances`);
    }
  }

}



// WEBPACK FOOTER //
// ./src/providers/balance-service/balance-service.ts